import { AfterContentInit, Component, ElementRef, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { OnlineStripContent, PageContent } from 'src/app/models';
import { ContentService } from 'src/app/services/content/content.service';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { CenterSectionComponent } from 'src/app/shared/components';
import { StripContainerComponent } from 'src/app/shared/layout/strips/strip-container.component';
import { environment } from 'src/environments/environment';
import { SanitizeHtmlPipe } from '../../../../shared/pipes/sanitize-html.pipe';

@Component({
  selector: 'app-simple-content',
  templateUrl: './simple-content.component.html',
  styleUrls: ['./simple-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CenterSectionComponent, SanitizeHtmlPipe, StripContainerComponent],
})
export class SimpleContentComponent implements AfterContentInit, OnDestroy {
  private contentService = inject(ContentService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private themeService = inject(ThemeService);
  private elRef = inject(ElementRef);
  private deviceService = inject(DeviceDetectorService);

  private readonly contentUrl = `${environment.urls.content.merchant_content}/`;

  private subscription = new Subscription();
  title: string;
  hideTitle: boolean;
  body: string;
  strips: OnlineStripContent[];

  constructor() {
    this.subscription.add(
      this.activatedRoute.url.subscribe((url) => {
        const contentId = this.contentUrl + url[0]?.path?.toLowerCase();

        const merchantContent = this.contentService.getMerchantPages();
        const content = merchantContent.get(contentId);
        if (!content) {
          this.router.navigate([environment.urls.page_not_found]);
          return;
        }

        this.title = content.titleText;
        this.hideTitle = content.hideTitle;
        this.body = content.contentText;

        if (this.deviceService.isMobile() && content.mobileContentText) {
          this.body = content.mobileContentText;
        }

        this.body = this.contentService.addImageSource(this.body);
        this.body = this.contentService.addLinkSource(this.body);

        this.strips = this.contentService.getOnlinePageContent(contentId);

        this.setSEO(content);
      }),
    );
  }

  ngAfterContentInit() {
    this.themeService.subscribeComponent(this.elRef);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setSEO(content: PageContent) {
    const { titleText, pageTitle, pageDescription } = content;

    this.contentService.setTitle(pageTitle || titleText);
    this.contentService.setDescription(pageDescription);
    this.contentService.setNoIndex(false);
  }
}
